export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}search/search`;
    return $resource(url, null, {
        getAutocompleteResults: {
            method: 'GET',
            isArray: false,
            url
        },
        getCourses: {
            method: 'GET',
            isArray: true,
            url: `${url}/course`
        },
        getEmployees: {
            method: 'GET',
            isArray: true,
            url: `${url}/employee`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Search/index.js